var map = {
	"./mob_alert_partner_gold_x1.png": 805,
	"./mob_alert_partner_platinum_x1.png": 806,
	"./mob_alert_partner_silver_x1.png": 807,
	"./mob_alert_partner_white_x1.png": 808
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 453;